
import React, { useState } from 'react';
import { supabase } from './supabaseClient';

function App() {
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [session, setSession] = useState(null);
  const [method, setMethod] = useState('phone'); // 'phone' or 'email'

  const handleLogin = async () => {
    if (method === 'phone') {
      const { error } = await supabase.auth.signInWithOtp({ phone });
      if (error) console.error('Error sending OTP:', error.message);
    } else {
      const { error } = await supabase.auth.signInWithOtp({ email });
      if (error) console.error('Error sending OTP:', error.message);
    }
  };

  const verifyOtp = async () => {
    const payload = method === 'phone'
      ? { phone, token: otp, type: 'sms' }
      : { email, token: otp, type: 'email' };

    const { data, error } = await supabase.auth.verifyOtp(payload);
    if (error) console.error('Verification failed:', error.message);
    else setSession(data.session);
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Login with {method === 'phone' ? 'Phone' : 'Email'}</h2>

      <button onClick={() => setMethod('phone')}>Use Phone</button>
      <button onClick={() => setMethod('email')}>Use Email</button>
      <br /><br />

      {method === 'phone' ? (
        <input
          placeholder="Phone (+1234567890)"
          onChange={(e) => setPhone(e.target.value)}
        />
      ) : (
        <input
          placeholder="Email"
          onChange={(e) => setEmail(e.target.value)}
        />
      )}
      <button onClick={handleLogin}>Send OTP</button>

      <br /><br />
      <input
        placeholder="Enter OTP"
        onChange={(e) => setOtp(e.target.value)}
      />
      <button onClick={verifyOtp}>Verify OTP</button>

      {session && <p>✅ Logged in!</p>}
    </div>
  );
}

export default App;

